import React, {useEffect, useState} from "react";
import {TextInput, TouchableOpacity, View} from "react-native";
import {Picker} from "@react-native-community/picker";
import PtIcon from "../../core/pt-icon/pt-icon";
import {styleVars} from "../../../app-style-vars";
import {PtOrderHistorySearchProps} from './pt-order-history-search-props';
import {styles} from './pt-order-history-search-styles';

export default function PtOrderHistorySearch(props: PtOrderHistorySearchProps) {

  const searchContainerStyle = props.show ? styles.searchContainerShown : null;
  const searchOptions = props.searchOptions || [];

  const initialSelection = props.requestParams.searchType;
  const initialSearchValue = props.requestParams.searchTerm || '';

  const [orderHistorySearchType, setOrderHistorySearchType] = useState(initialSelection);
  const [orderHistorySearchValue, setOrderHistorySearchValue] = useState(initialSearchValue);


  useEffect(() => {
    if(props.searchTypeChangedHandler) {
      setOrderHistorySearchType(initialSelection);
    }
    if(props.searchTermChangedHandler) {
      setOrderHistorySearchValue(initialSearchValue);
    }
  })

  const doSearch = () => {
    if(props.searchHandler) {
      props.searchHandler();
    }
  }

  const searchTypeChanged = (newVal:any) => {
    if(props.searchTypeChangedHandler) {
      props.searchTypeChangedHandler({searchType: newVal});
    } else {
      setOrderHistorySearchType(newVal);
    }
  }

  const searchTermChanged = (newVal:any) => {
    console.log('the e on text input changed = ', newVal);
    if(props.searchTermChangedHandler) {
      props.searchTermChangedHandler({searchTerm: newVal})
    } else {
      setOrderHistorySearchValue(newVal);
    }
  }

  return (
    <View style={[styles.searchContainer, searchContainerStyle]}>
      <Picker
        selectedValue={orderHistorySearchType}
        style={[styles.picker]}
        onValueChange={(itemValue) => searchTypeChanged(itemValue)}
      >
        {searchOptions.map((option:any, idx:number) => (
          <Picker.Item value={option.value} label={option.label} key={idx}/>
        ))}
      </Picker>


      <View style={[styles.searchInputContainer]}>
        <TextInput
          style={[styles.searchInput]}
          onChangeText={(text) => searchTermChanged(text)}
          value={orderHistorySearchValue}
        />

        <TouchableOpacity onPress={() => doSearch()}>
          <View style={[styles.searchButton]}>
            <PtIcon iconName={'search'} iconSize={24} iconColor={styleVars.boschDarkBlue}/>
          </View>
        </TouchableOpacity>
      </View>


    </View>
  )
}